<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Formulario de Inspección</h1>
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer" no-body>
              <form-wizard
                color="#0074d9"
                errorColor="#ff4136"
                ref="wizard"
                shape="circle"
                stepSize="sm"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="onComplete"
                title=""
                @on-change="renewInfo"
                subtitle=""
              >
                <tab-content title="Datos de la Inspección" :before-change="submitFormInspeccion">
                  <b-alert :show="pendingInspections > 0" variant="warning"> Hay inspecciones pendientes </b-alert>
                  <formInspeccion :inspeccion="inspeccion" ref="formInspeccion"></formInspeccion>
                </tab-content>

                <tab-content title="Seleccionar Pallet a Inspeccionar" :before-change="terminarYGuardar">
                  <formInspeccionPallet :inspeccion="inspeccion" ref="formInspeccionPallet"></formInspeccionPallet>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import formInspeccion from "./formInspeccion.vue";
import formInspeccionPallet from "./formInspeccionPallet.vue";

import { shuffleArray } from "@/shared/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { bus } from "../../main";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "Inspeccion",
  components: {
    formInspeccion,
    formInspeccionPallet
  },
  mounted() {
    this.getPendingInspections();
  },
  props: ["InspeccionID"],
  data() {
    return {
      inspeccionSaved: false,
      inspeccion: {
        id: "",
        sif_number: "",
        sif_date: "",
        inspection_list: [],
        sag_worker: "",
        inspection_type: null,
        product: "",
        plant: "",
        destination_country: "",
        countries: ""
      },
      pendingInspections: 0
    };
  },
  computed: {},
  methods: {
    getPendingInspections() {
      this.$axios.get("/api/comex/inspection/pending_count/").then((res) => {
        this.pendingInspections = res.data.pending_count;
      });
    },
    loadBoarding(a) {},
    submitFormInspeccion() {
      var formValidacion = this.$refs.formInspeccion.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire("Campos requeridos o invalidos en el formulario", "", "warning");
        return false;
      } else {
        return true;
      }
    },

    async saveInspection(payload, arrayPallets, confirm = false) {
      if (Array.isArray(payload.countries)) {
        payload["countries"] = payload.countries.join(",");
      }
      payload["client"] = this.$store.state.user.ID_CLIENTE;
      payload["confirm"] = confirm;

      try {
        const res = await this.$axios.post("/api/comex/inspection/", payload);
        const status = res.data.status;
        if (status && status === "warning") {
          this.showConfirmSwal(res.data.message, res.data.id, arrayPallets);
          return;
        }
        const formData = {
          pallets: arrayPallets
        };
        const res2 = await this.$axios.put("/api/comex/inspection/" + res.data.id + "/set_packing_list/", formData);
        this.$swal.fire("Operación realizada con éxito", "", "success");
        this.$router.push("/exportaciones/lista-inspeccion");
        return true;
      } catch (error) {
        this.$swal.fire("Problemas al terminar proceso", "", "error");
        return false;
      }
    },
    showConfirmSwal(message, id, arrayPallets) {
      this.$swal
        .fire({
          title: "Advertencia",
          text: message,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "SI"
        })
        .then((result) => {
          if (result.value) {
            this.saveInspection(this.inspeccion, arrayPallets, true);
          }
        });
    },

    terminarYGuardar() {
      this.$swal
        .fire({
          title: "Seguro que quieres terminar?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "SI"
        })
        .then((result) => {
          if (result.value) {
            if (this.inspeccionSaved == false) {
              var padre = this;

              var objPallets = this.$refs.formInspeccionPallet.getpalletscheck();
              var arrayPallets = [];

              if (Object.keys(objPallets).length > 0) {
                for (var i = 0; i < Object.keys(objPallets).length; i++) {
                  arrayPallets[i] = objPallets[i].id;
                }
                let payload = this.inspeccion;

                this.saveInspection(payload, arrayPallets);
              } else {
                padre.$swal.fire("Por favor seleccione por lo menos un pallet", "", "info");
              }
            }
          }
        });
    },
    renewInfo: function (prevIndex, nextIndex) {},
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
